import Vue from 'vue';

Vue.component('staff-index', () =>
    import(/* webpackChunkName: 'staff-index' */ './staff-index.vue'),
);
